import { Query, getResult, setFilter, setSort } from '@btime/query-monad'
import { generateContext } from '@btime/react-contexts'
import { useApi } from '@btime/react-api'
import React, { useContext } from 'react'

import { useCurrentModal } from '../../../../../../components/modals/ModalsContext'
import { useLoader } from '../../../../../../utils/loader/loader.hook'

const { StateContext, Provider } = generateContext()
export const useLogs = () => useContext(StateContext)

const StacktraceLoader = ({ children }) => {
  const [state, setList] = React.useState([])
  const { data: log } = useCurrentModal()
  const listLogsEndpoint = useApi('listLogsEndpoint')

  const callApi = stateControl => {
    const { clearState, setEmpty, setErrorMessage, stopAllLoadings } = stateControl

    clearState()

    Query({ ignore401: true })
      .map(setSort({ field: 'happenedAt', type: 'ASC' }))
      .map(setFilter('requestIds', [log.requestId]))
      .map(listLogsEndpoint)

      .chainThen(queryResponse => {
        queryResponse
          .map(getResult) //
          .jump(setList)
          .map(stopAllLoadings)
      })
      .catch(e => setErrorMessage(e.message))
  }

  const { render } = useLoader(callApi, [])

  return <Provider state={state}>{render || children}</Provider>
}

export default StacktraceLoader
